import Image from 'next/image';
import { ReactNode } from 'react';

type GreenCTASectionProps = {
  title: string;
  subtitle?: string;
  children: ReactNode;
};

export function GreenCTASection({ title, subtitle, children }: GreenCTASectionProps) {
  return (
    <div className="relative overflow-hidden bg-primary px-6 py-14 md:px-20 md:py-16 rounded-xl flex flex-col items-center gap-6 text-center [&_a:focus-visible]:outline-white [&_button:focus-visible]:outline-white">
      {/* Decorative blobs at top-left — exported from Figma, matched to donate Support Our Work band */}
      <div aria-hidden className="hidden md:block absolute pointer-events-none" style={{ left: 0, top: 0 }}>
        <Image src="/donate-support-blob-sage-desktop.svg" alt="" width={66} height={84} />
      </div>
      <div aria-hidden className="hidden md:block absolute pointer-events-none" style={{ left: '19.27px', top: 0 }}>
        <Image src="/donate-support-blob-olive-desktop.svg" alt="" width={189} height={67} />
      </div>
      <div aria-hidden className="hidden md:block absolute pointer-events-none" style={{ left: '19.27px', top: 0 }}>
        <Image src="/donate-support-blob-slate-desktop.svg" alt="" width={47} height={44} />
      </div>
      <div aria-hidden className="md:hidden absolute pointer-events-none" style={{ left: 0, top: 0 }}>
        <Image src="/donate-support-blob-sage-mobile.svg" alt="" width={55} height={58} />
      </div>
      <div aria-hidden className="md:hidden absolute pointer-events-none" style={{ left: '22.64px', top: 0 }}>
        <Image src="/donate-support-blob-olive-mobile.svg" alt="" width={130} height={47} />
      </div>
      <div aria-hidden className="md:hidden absolute pointer-events-none" style={{ left: '22.64px', top: 0 }}>
        <Image src="/donate-support-blob-slate-mobile.svg" alt="" width={32} height={31} />
      </div>

      <h2 className="relative text-3xl font-semibold text-white font-[family-name:var(--font-abhaya-libre)]">
        {title}
      </h2>
      {subtitle && (
        <p className="relative text-base text-white/80 leading-relaxed max-w-xl">{subtitle}</p>
      )}
      <div className="relative flex flex-wrap justify-center gap-4">{children}</div>
    </div>
  );
}
